import React from 'react';
import { Create, useForm } from '@refinedev/antd';
import { useNavigation } from '@refinedev/core';
import { Form, Input, InputNumber, Switch, message } from 'antd';
import { LocalizedContentTabs, normalizeTranslations } from '../../components/LocalizedContentTabs';

const LANG_FIELDS = [
  { key: 'name', label: 'Name', placeholder: 'e.g. Hydration Hero', required: true },
  { key: 'description', label: 'Description', placeholder: 'Describe the badge...', textarea: true, rows: 4 },
];

export const BadgeCreate: React.FC = () => {
  const { formProps, onFinish } = useForm({ resource: 'badges' });
  const { push } = useNavigation();

  const handleSubmit = async (values: any) => {
    try {
      await onFinish({
        ...values,
        translations: normalizeTranslations(values.translations, LANG_FIELDS),
      });
      message.success('Badge created');
      push('/badges');
    } catch (err: any) {
      message.error(err?.message || 'Failed to create badge');
    }
  };

  return (
    <Create resource="badges" saveButtonProps={{ onClick: () => formProps.form?.submit() }}>
      <Form {...formProps} layout="vertical" onFinish={handleSubmit}>
        <LocalizedContentTabs fields={LANG_FIELDS} />
        <Form.Item label="Image URL" name="imageUrl">
          <Input placeholder="https://..." />
        </Form.Item>
        <Form.Item label="Price (Coins)" name="priceCoins" initialValue={0}>
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
        <Form.Item label="Category" name="category">
          <Input placeholder="e.g. fitness, nutrition, streak" />
        </Form.Item>
        <Form.Item label="Tier" name="tier">
          <Input placeholder="e.g. bronze, silver, gold" />
        </Form.Item>
        <Form.Item label="Sort Order" name="sortOrder" initialValue={0}>
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item label="Active" name="isActive" valuePropName="checked" initialValue={true}>
          <Switch />
        </Form.Item>
      </Form>
    </Create>
  );
};
